export default {"src":"/_next/static/media/phone.1c412395.svg","height":24,"width":25,"blurWidth":0,"blurHeight":0};